import React, { useState } from 'react';
import { Col, Container, Nav, NavLink, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "../Video/Video.css";
import { Link } from 'react-router-dom';

const Video = ({ video }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <section className='video-wrp' id='video'>
                <Container>
                    <div className='video-inner'>
                        <div className='features-title'>
                            <div className='sub-title'>
                                <span>{video.subtitle}</span>
                            </div>    
                            <div className='section-title'>
                                <h2>{video.sectiontitle}</h2>
                            </div>    
                        </div>        
                        <div className='video-main'>
                            <div className='video-top'>
                                <div className='video-img'>
                                    <img src={video.videoimg} alt={video.alt} className='img-fluid' />
                                </div>
                                <Button className='play-icon' onClick={handleShow}>
                                    <img src={video.playicon} alt={video.alt} className='img-fluid'/>
                                </Button>
                            </div>
                            <div className='video-bottom'>
                                <Row className='align-items-center'>
                                    <Col xs={6} sm={7} md={7} lg={7} xl={7} xxl={7}>
                                        <div className='block-title'>
                                            <h3>{video.blocktitle}</h3>
                                        </div>
                                    </Col>
                                    <Col xs={6} sm={5} md={5} lg={5} xl={5} xxl={5}>
                                        <div className='video-btn'>
                                            <Nav.Link href="/home#star-for-free" className='btn btn-blue'>{video.btn}</Nav.Link>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            <Modal className='video-modal' show={show} onHide={handleClose} centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <video autoPlay muted playsInline loop>
                        <source src={video.videoSrc} type="video/mp4" />
                    </video>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Video;
